import React from 'react';
import RowActions from '../RowActions/RowActions';

export const withRowActions = <P extends { rowData: $TSFixMe; children?: $TSFixMe }>(
    WrappedComponent: React.ComponentType<React.PropsWithChildren<P>>
): typeof WrappedComponent => props => {
    return (
        <RowActions {...props}>
            <WrappedComponent {...props} />
        </RowActions>
    );
};
